// Local email + password sign-in. Returns the same Avalanche session JWT the
// QuestionPro exchange issues, so nothing downstream cares which was used.
// Reads the base URL directly rather than importing it from api/utils, which
// would create an import cycle back through useAuth.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default async function loginWithCredentials(email, password) {
  const response = await fetch(`${API_BASE_URL}api/v1/authorization/login/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    if (response.status === 429) {
      throw new Error('Too many sign-in attempts. Please wait a minute and try again.');
    }
    throw new Error(payload?.response?.message || 'Could not sign you in');
  }
  return payload.data.access_token;
}

// Replaces a temporary password. Returns a fresh session JWT so the caller is
// never left holding one minted before the change.
export async function changePassword(token, currentPassword, newPassword) {
  const response = await fetch(`${API_BASE_URL}api/v1/authorization/change-password/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ current_password: currentPassword, new_password: newPassword }),
  });

  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(payload?.response?.message || 'Could not change your password');
  }
  return payload.data.access_token;
}
